import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://uexgzuxxicjshmbcgwzr.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVleGd6dXh4aWNqc2htYmNnd3pyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTczMTIzNDIsImV4cCI6MjA3Mjg4ODM0Mn0.6X1aaoa_HRkAtanwepkVbns5LYJ8_7JftGSZ20pkBW4'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})